/**
 * Remove todos os caracteres que não são letras ou dígitos e converte para maiúscula.
 * Utilizado para sanitizar CNPJs alfanuméricos.
 *
 * @param value - String contendo o CNPJ com ou sem formatação
 * @returns String contendo apenas caracteres alfanuméricos em maiúscula
 */
export const sanitizeAlphanumericCnpj = (value: string): string => {
  return value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
};
